import smoothscroll from '../lib/smoothscroll.min.js';

class Totop {
  constructor(config = {}) {
    const {
      buttonSelector,
    } = config;

    this.buttonSelector = document.querySelector(buttonSelector);
    this.lastScrollPos = 0;

    if (this.buttonSelector) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.buttonSelector.addEventListener('click', () => {
      smoothscroll.polyfill(); //behavior smooth doesn't work in ie/edge
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    });
  }
}

export default Totop;
